import { compose, concat, defaultTo, find, juxt, propOr, propEq } from 'ramda';
import { DEFAULT_PHONE } from './ensurePhonesArray.js';

export const formatPhone = (phones, mobile = true) =>
  compose(
    (phone) => concat(propOr('', 'internationalCode', phone), propOr('', 'number', phone)),
    find(propEq('isMobile', mobile))
  )(phones);

const findPhoneByType = (isMobile, defaultPhone) =>
  compose(defaultTo(defaultPhone), find(propEq('isMobile', isMobile)));

export const orderPhonesByType = compose(
  juxt([findPhoneByType(true, DEFAULT_PHONE), findPhoneByType(false, {})]),
  defaultTo([])
);
